<template>
	<div class="dynamic">
		<interface-navigation />
		<transition-fade>
			<router-view class="page-content h-content md:min-h-full" keep-alive>
			</router-view>
		</transition-fade>
		<interface-footer />
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';

	import fade from '@/components/fade';
	import interface_navigation from '@/components/interface/navigation';
	import interface_footer from '@/components/interface/footer';

	export default {
		name: 'home',
		components: {
			'interface-footer': interface_footer,
			'interface-navigation': interface_navigation,
			'transition-fade': fade
		}
	};
</script>
